import { render, staticRenderFns } from "./AddTermsAndConditionsModal.vue?vue&type=template&id=70848d84&scoped=true&"
import script from "./AddTermsAndConditionsModal.vue?vue&type=script&lang=js&"
export * from "./AddTermsAndConditionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70848d84",
  null
  
)

export default component.exports